import axios from 'axios';

export default {
    fetchSettings(settings) {
        return axios.post('/settings/fetchSettings', { settings });
    },
    updateSettings(settings) {
        return axios.post('/settings/updateSettings/', { settings });
    },
    fetchDebugMenuInfo() {
        return axios.post('/settings/fetchDebugMenuInfo/');
    },
};
